import { lineItemsV2TableState } from './types';
import { expandedIdVar, filtersVar, initialLoadingVar, paginationVar, sortVar } from './vars';

export const lineItemsV2TableCache = {
  lineItemsV2Table: {
    read: (): lineItemsV2TableState => ({
      sort: sortVar(),
      pagination: paginationVar(),
      filterQuery: filtersVar().filterQuery,
      initialLoading: initialLoadingVar(),
      expandedId: expandedIdVar(),
    }),
  },
};
